module.exports = __webpack_public_path__ + "img/9592891.jpeg";